import React from 'react';
import './listPage.css';

/**
 * Λεπτομέρειες σε συρτάρι ή ενότητα: λίστα ετικέτα → τιμή (<dl>), ετικέτα αχνή αριστερά, τιμή δεξιά,
 * λεπτή γραμμή ανάμεσα. Κενή τιμή (null/undefined/'') = «—», ώστε η σειρά να μη χάνεται.
 */

export interface KeyValueItem {
  label: React.ReactNode;
  value: React.ReactNode;
  /** Δεύτερη, αχνή γραμμή κάτω από την τιμή. */
  hint?: React.ReactNode;
  /** Σταθερό κλειδί (αλλιώς η θέση). */
  id?: string;
}

export interface KeyValueProps {
  items: KeyValueItem[];
  testId?: string;
}

const isBlank = (v: React.ReactNode): boolean => v === null || v === undefined || v === '' || v === false;

export const KeyValue: React.FC<KeyValueProps> = ({ items, testId }) => (
  <dl className="lp-kv" data-testid={testId}>
    {items.map((item, i) => (
      <div key={item.id ?? i} className="lp-kv-row">
        <dt className="lp-kv-label">{item.label}</dt>
        <dd className="lp-kv-value">
          {isBlank(item.value) ? '—' : item.value}
          {!isBlank(item.hint) && <span className="lp-kv-hint">{item.hint}</span>}
        </dd>
      </div>
    ))}
  </dl>
);

/**
 * Ένας αριθμός μέσα σε κείμενο («Σύνολο 234,50 €»): ΑΠΛΟ κείμενο σε γραμμή, όχι κουτί/κάρτα με χρώμα.
 * Πολλά μαζί: <Stats>…</Stats> (μία γραμμή που αναδιπλώνεται).
 */
export interface StatProps {
  label: React.ReactNode;
  value: React.ReactNode;
  hint?: React.ReactNode;
}

export const Stat: React.FC<StatProps> = ({ label, value, hint }) => (
  <span className="lp-stat">
    <span className="lp-stat-label">{label}</span>{' '}
    <span className="lp-stat-value">{value}</span>
    {!isBlank(hint) && <>{' '}<span className="lp-stat-hint">{hint}</span></>}
  </span>
);

export const Stats: React.FC<{ children: React.ReactNode; testId?: string }> = ({ children, testId }) => (
  <div className="lp-stats" data-testid={testId}>{children}</div>
);

export default KeyValue;
